import { memo } from "react";

// Generate stable keys for static skeleton loops (avoids lint "index-as-key" warnings)
const skeletonKeys = (n) => Array.from({ length: n }, (_, i) => `skel-${i}-${Math.random().toString(36).slice(2, 6)}`);

export const SkeletonRows = memo(({ count = 5, className = "h-16 skeleton rounded-lg" }) => {
  const keys = skeletonKeys(count);
  return (
    <>
      {keys.map((k) => (
        <div key={k} className={className} />
      ))}
    </>
  );
});

export const ProductCardSkeleton = memo(() => (
  <div className="glass rounded-2xl overflow-hidden animate-pulse" data-testid="product-skeleton">
    <div className="aspect-square bg-white/5" />
    <div className="p-5 space-y-3">
      <div className="h-4 bg-white/5 rounded w-3/4" />
      <div className="h-3 bg-white/5 rounded w-1/2" />
      <div className="flex justify-between items-center pt-2">
        <div className="h-5 bg-white/5 rounded w-16" />
        <div className="h-8 bg-white/5 rounded w-20" />
      </div>
    </div>
  </div>
));

export const ProductGridSkeleton = memo(({ count = 6 }) => {
  const keys = skeletonKeys(count);
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
      {keys.map((k) => (
        <ProductCardSkeleton key={k} />
      ))}
    </div>
  );
});

export const ProductDetailSkeleton = memo(() => (
  <div className="animate-pulse" data-testid="product-detail-skeleton">
    <div className="grid lg:grid-cols-2 gap-12">
      <div className="aspect-square bg-white/5 rounded-2xl" />
      <div className="space-y-4">
        <div className="h-8 bg-white/5 rounded w-3/4" />
        <div className="h-4 bg-white/5 rounded w-1/3" />
        <div className="h-6 bg-white/5 rounded w-24 mt-4" />
        <div className="space-y-2 mt-6">
          <div className="h-3 bg-white/5 rounded w-full" />
          <div className="h-3 bg-white/5 rounded w-5/6" />
          <div className="h-3 bg-white/5 rounded w-4/6" />
        </div>
        <div className="h-12 bg-white/5 rounded-xl mt-8" />
      </div>
    </div>
  </div>
));

export const PageSkeleton = memo(() => {
  const keys = skeletonKeys(6);
  return (
    <div className="min-h-screen bg-[#06070A]">
      <div className="h-16 bg-[#06070A] border-b border-white/5" />
      <div className="max-w-7xl mx-auto px-6 pt-32 pb-24 animate-pulse">
        <div className="h-10 bg-white/5 rounded w-64 mb-4" />
        <div className="h-4 bg-white/5 rounded w-96 mb-12" />
        <div className="grid md:grid-cols-3 gap-6">
          {keys.map((k) => (
            <div key={k} className="h-64 bg-white/5 rounded-2xl" />
          ))}
        </div>
      </div>
    </div>
  );
});

ProductCardSkeleton.displayName = "ProductCardSkeleton";
ProductGridSkeleton.displayName = "ProductGridSkeleton";
ProductDetailSkeleton.displayName = "ProductDetailSkeleton";
PageSkeleton.displayName = "PageSkeleton";
SkeletonRows.displayName = "SkeletonRows";
